<app-header></app-header>
<div class="container">
<div class="breadcrumbs mt-4">
  <div routerLink="/">Главная</div>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <div routerLink="/events">Лента событий</div>
</div>
<div class="row">
  <h1 class="w-100 mt-70">Лента событий
  </h1>
  <h2>2024 год</h2>

  <ul class="marked ml-50">
    <li><h4>Октябрь</h4></li>
  </ul>

  <p>В октябре мы внесли в государственный реестр более 10 заключений экспертизы промышленной безопасности, а также провели ЭПБ и завершили подготовку документации более чем для 15 организаций.</p>

  <ul class="marked ml-50">
    <li><h4>Сентябрь</h4></li>
  </ul>

  <p>В сентябре наши специалисты провели ряд ЭПБ и&nbsp;подготовили более 20 заключений, часть из которых уже внесена в реестр Ростехнадзора.</p>

  <ul class="marked ml-50">
    <li><h4>Август</h4></li>
  </ul>

  <p>За август нашими экспертами были проведены экспертизы промбезопасности,&nbsp; технические освидетельствования и оформлены заключения ЭПБ более чем для 20 компаний, 8 из них уже включены в государственный реестр.</p>

  <ul class="marked ml-50">
    <li><h4>Июль</h4></li>
  </ul>

  <p>В июле наши эксперты выполнили работы более чем для 20 компаний, часть заключений уже внесена в государственный реестр Ростехнадзора.&nbsp;</p>

  <ul class="marked ml-50">
    <li><h4>Июнь</h4></li>
  </ul>

  <p>В июне нашими специалистами были подготовлены заключения экспертизы промышленной безопасности&nbsp;(ЭПБ) и&nbsp;проведены обследования более чем для 20 компаний, ряд заключений&nbsp;уже зарегистрирован в государственном реестре.</p>

  <ul class="marked ml-50">
    <li><h4>Май</h4></li>
  </ul>

  <p>Более чем для 20 компаний было мае 2024 года специалисты ООО &quot;Протос Экспертиза&quot; более чем для 20 компаний провели и оформили заключения ЭПБ, часть из которых уже внесена в государственный реестр.</p>

  <ul class="marked ml-50">
    <li><h4>Май</h4></li>
  </ul>

  <p>В мае 2024 года специалисты ООО &quot;Протос Экспертиза&quot; более чем для 20 компаний провели и оформили заключения ЭПБ, часть из которых уже внесена в государственный реестр.</p>

  <ul class="marked ml-50">
    <li><h4>Апрель</h4></li>
  </ul>

  <p>В апреле лаборатория неразрушающего контроля ООО &quot;Протос Экспертиза&quot; успешно прошла очередную аттестацию.</p>

  <p>Также более чем для 15 клиентов нашей компании мы провели мероприятия по техническому освидетельствованию и диагностированию и&nbsp;завершили оформление заключений ЭПБ, часть из которых уже внесли в государственный реестр.</p>

  <ul class="marked ml-50">
    <li><h4>Март</h4></li>
  </ul>

  <p>В марте 2024 года более чем для 15 компаний мы:</p>

  <ul class="marked ml-50">
    <li>провели&nbsp;техническое освидетельствование и диагностирование;</li>
    <li>завершили оформление заключений ЭПБ, часть из которых уже внесена в соответствующий реестр.</li>
  </ul>
  <ul class="marked ml-50 w-100">
  <li>
    <h4>Февраль</h4>
  </li>
  </ul>
  <p>В феврале мы подготовили проекты и отчеты&nbsp;технического диагностирования более чем для 10 компаний и&nbsp;внесли в реестр ряд заключений экспертиз промышленной безопасности.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Январь</h4>
    </li>
  </ul>

  <p>Год начался с оформления документации, проведения ЭПБ, ТД и ТО, а также внесения заключений в реестр Ростехнадзора более чем для 10 компаний.&nbsp;</p>

  <p>&nbsp;</p>

  <h2>2023 год</h2>

  <p>В 2023 году силами ООО &quot;Протос Экспертиза&quot; было проведено<strong> более 200 экспертиз промышленной безопасности</strong> проектов, технических устройств, зданий и сооружений, заключения по которым уже внесены в реестр Ростехнадзора.</p>

  <p>Также наши специалисты за этот год подготовили <strong>отчеты более чем для 130</strong> обратившихся к нам организаций, многие из которых -наши постоянные клиенты:</p>

  <ul class="marked ml-50">
    <li>
      <h4>Октябрь</h4>
    </li>
  </ul>

  <p>В октябре 2023 года специалисты ООО &quot;Протос Экспертиза&quot; более чем для 15 компаний провели <strong>техническое диагностирование ТУ и ГПМ, а также&nbsp;ряд экспертиз&nbsp;промышленной безопасности</strong>, часть из которых уже завершена, а заключения внесены в реестр Ростехнадзора.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Сентябрь</h4>
    </li>
  </ul>

  <p>За сентябрь специалистами ООО &quot;Протос Экспертиза&quot; было проведено техническое диагностирование ТУ и ЗиС более чем для 10 организаций, эксплуатирующих ОПО, а также <strong>завершено оформление отчетов по оказанным услугам</strong>. &nbsp;Помимо вышеуказанных работ, в реестр Ростехнадзора были внесены заключения по ранее проведенным ЭПБ.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Август</h4>
    </li>
  </ul>

  <p>В августе наши специалисты провели<strong> экспертизу промышленной безопасности и техническое диагностирование более чем для 20 заказчиков,</strong> для 8 из которых на конец месяца были подготовлены соответствующие заключения, а для 4 из них - сведения уже внесены в реестр Ростехнадзора.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Июль</h4>
    </li>
  </ul>

  <p>В июле специалистами ООО &quot;Протос Экспертиза&quot; были подготовлены заключения по ранее проведенным ЭПБ и выполнены технические диагностирования<strong> более чем для 10 предприятий.</strong><br />
    Часть заключений уже внесена в реестр Ростехнадзора.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Июнь</h4>
    </li>
  </ul>

  <p>В июне специалисты нашей компании завершили ряд экспертиз промышленной безопасности, в том числе внесли часть заключений в реестр Ростехнадзора.</p>

  <p>А также <strong>приступили к обследованию более чем 10 опасных производственных объектов</strong> на территории РФ.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Май</h4>
    </li>
  </ul>

  <p>﻿В мае 2023 года специалисты ООО &quot;Протос Экспертиза&quot; провели Э<strong>ПБ более чем для&nbsp;10&nbsp;организаций</strong>, эксплуатирующих опасные производственные объекты.<br />
    <br />
    Также были получены уведомления об успешном <strong>внесении в госреестр Ростехнадзора</strong> зарегистрированных заключений, проведены и подготовлены отчеты по техническому диагностированию ТУ и ЗС, использующихся в процессе эксплуатации ОПО.&nbsp;</p>

  <ul class="marked ml-50">
    <li>
      <h4>Апрель</h4>
    </li>
  </ul>

  <p>Специалисты нашей компании провели ряд <strong>ЭПБ</strong>, включая экспертизы технических устройств, зданий и сооружений <strong>не только в Центральном федеральном округе, но и в других регионах.</strong><br />
    Заключения по части экспертиз промышленной безопасности, завершенных в апреле, были внесены в реестр Ростехнадзора.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Март</h4>
    </li>
  </ul>

  <p>В марте 2023 года экспертами проводились диагностирование и освидетельствование технических устройств и грузоподъемных механизмов, <strong>экспертиза промышленной безопасности</strong> технических устройств и документации <strong>более чем для 15 организаций</strong>, эксплуатирующих опасные производственные объекты. Также были получены уведомления о внесении в реестр Ростехнадзора заключений, подготовленных ООО &quot;Протос Экспертиза&quot; в конце февраля.</p>

  <ul class="marked ml-50 w-100">
    <li>
      <h4>Февраль</h4>
    </li>
  </ul>


  <p>В феврале 2023 года наши специалисты провели <strong>экспертизы промышленной безопасности</strong> проектов, зданий и железнодорожных путей, а также <strong>техническое освидетельствование</strong> грузоподъемных механизмов. Несколько заключений уже <strong>внесены в реестр Ростехнадзора</strong>, а оставшиеся- ожидают окончания процедуры регистрации. Как обычно, все мероприятия выполнены строго в указанные в договорах сроки.</p>

  <ul class="marked ml-50">
    <li>
      <h4>Январь</h4>
    </li>
  </ul>

  <p>Несмотря на затяжные новогодние праздники, наши <strong>специалисты</strong> уже <strong>провели ряд экспертиз проектной документации</strong>, а также <strong>экспертизы промышленной безопасности и обследования зданий и сооружений</strong> для постоянных и новых заказчиков, <strong>семь из которых уже успешно завершены</strong> в части оформления.</p>

  <h2>2022 год</h2>

  <p>За 2022 год <strong>мы оправдали доверие более чем 100</strong> государственных и коммерческих <strong>организаций</strong>, которым специалисты ООО &laquo;Протос Экспертиза&raquo; помогали решать самые разнообразные вопросы, связанные с промышленной безопасностью.</p>

  <p>Так, <strong>за 2022 год</strong> мы провели <strong>более 260 экспертиз и технических освидетельствований </strong>опасных производственных объектов, в том числе с помощью <strong>собственной лаборатории неразрушающего контроля.</strong></p>

  <h2>2003-2022 год</h2>

  <p><strong>С момента основания</strong> ООО &laquo;Протос Экспертиза&raquo; на конец 2022 года специалистами и экспертами было оказано <strong>более 3000 услуг для более чем 700 компаний,</strong> расположенных в Российской Федерации, многие из которых стали нашими постоянными клиентами.</p>

  <p><strong>Среди оказанных нами услуг:</strong></p>

  <ul class="marked ml-50">
    <li>Проведение <strong>экспертиз промышленной безопасности</strong> зданий, сооружений, резервуаров, грузоподъемных механизмов и других ОПО;</li>
    <li><strong>Техническое диагностирование и техническое освидетельствование</strong> котлов, газопроводов, технических устройств, конструкций и прочих объектов;</li>
    <li><strong>Идентификация</strong> опасных производственных объектов;</li>
    <li>Оформление <strong>лицензий и внесение ОПО</strong> в соответствующие реестры;</li>
    <li><strong>Аудит и разработка документации ОПО</strong>, в том числе планов мероприятий по локализации и ликвидации последствий аварий (ПМЛА), порядка проведения расследований инцидентов (ПРИ), деклараций промышленной безопасности и иной документации;</li>
    <li><strong>Разработка проектов ликвидации, консервации и технического перевооружения</strong> опасных производственных объектов.</li>
  </ul>

  <p>Эксперты нашей компании регулярно повышают свою квалификацию и отслеживают все изменения в нормативных документах РФ, связанных с опасными производственными объектами.</p>

  <p>На протяжении многих лет основными принципами работы были и остаются: <strong>честность, внимание к деталям и тщательное изучение документации и/или объектов</strong>, подлежащих экспертизе, диагностике и техническому освидетельствованию. <strong>Мы работаем, чтобы мир был безопаснее!</strong></p>

</div>
</div>
<app-footer></app-footer>
